const e = "beacon-scroll-block";
function n() {
  var o;
  if (!document.getElementById(e)) {
    const t = document.createElement("style");
    t.setAttribute("id", e), t.innerHTML = `.${e}{
      block-size: 100dvh !important;
      overflow: hidden !important;
    }`, (o = document.querySelector("head")) == null || o.appendChild(t);
  }
  document.body.classList.add(e);
}
function c() {
  document.body.classList.remove(e);
}
export {
  n as d,
  c as e
};
